import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Layout, LayoutBlock } from 'components/Layout';
import { IntituteType } from 'propTypes/entities';
import CatalogEvents from './components/CatalogEvents';
import CatalogRedirectSection from './components/CatalogRedirectSection';
import PromoSection from './components/PromoSection';
import MuseumsSection from './components/MuseumsSection';

const getNoIndex = (urlParams) =>
	!!urlParams.seanceStartDate || !!urlParams.seanceEndDate;

const MainTemplate = ({ limit, total, urlParams, textBlocks, institutes }) => {
	const [noIndex, setNoIndex] = useState(getNoIndex(urlParams));

	useEffect(() => {
		setNoIndex(getNoIndex(urlParams));
	}, [urlParams]);

	const institutesExist = !_.isEmpty(institutes);

	const anchors = institutesExist
		? [
				{
					title: 'Афиша',
					url: '#afisha'
				},
				{
					title: 'Учреждения',
					url: '#institutes'
				}
		  ]
		: [];

	return (
		<Layout {...{ textBlocks, noIndex, anchors }}>
			<PromoSection />

			<LayoutBlock anchorId="afisha">
				<CatalogEvents {...{ total, urlParams, limit }} />
			</LayoutBlock>

			{institutesExist ? (
				<LayoutBlock anchorId="institutes">
					<MuseumsSection museums={institutes} />
				</LayoutBlock>
			) : null}

			<LayoutBlock>
				<CatalogRedirectSection />
			</LayoutBlock>
		</Layout>
	);
};

MainTemplate.propTypes = {
	limit: PropTypes.number.isRequired,
	total: PropTypes.number.isRequired,
	urlParams: PropTypes.object.isRequired,
	textBlocks: PropTypes.object,
	institutes: PropTypes.arrayOf(IntituteType)
};

export default MainTemplate;
